function PasswordService(ApiService) {
  'ngInject';

  const service = {};
  service.sendEmail  = function(email, path, callbackFunc) {
    let data = {
      email: email,
      redirect_url: path
    };
    ApiService.post(`/auth/password`, data, callbackFunc);
  };

  service.resetPassword  = function(passwordForm, header, callbackFunc) {
    let data = {
      password: passwordForm.password,
      password_confirmation: passwordForm.confirm_password
    };
    ApiService.resetPassword(`/auth/password`, data, header, callbackFunc);
  };
  return service;
}

export default {
  name: 'PasswordService',
  fn: PasswordService
};
